module.exports = __webpack_public_path__ + "img/banner-36.78c06c64.jpg";